import React from 'react'
import CameraComponent from '../../components/CameraComponent'
// import ImageOne from '../../assets/images/las-vegas-sign-001.jpg'
// import ImageTwo from '../../assets/images/bangkok-food-001.jpg'
// import ImageThree from '../../assets/images/london-image-001.jpg'
import SliderOneImage from '../../assets/images/slider_0000_tripadvisor-min.jpg'
import SliderTwoImage from '../../assets/images/slider_0001_tripadvisor-min.jpg'
import SliderThreeImage from '../../assets/images/slider_0002_tripadvisor-min.jpg'
import SliderFourImage from '../../assets/images/slider_0003_tripadvisor-min.jpg'
import SliderFiveImage from '../../assets/images/slider_0004_tripadvisor-min.jpg'
import SliderSixImage from '../../assets/images/slider_0005_tripadvisor-min.jpg'
import SliderSevenImage from '../../assets/images/slider_0006_tripadvisor-min.jpg'
import SliderEightImage from '../../assets/images/slider_0007_tripadvisor-min.jpg'
import SliderNineImage from '../../assets/images/slider_0008_tripadvisor-min.jpg'
// import SliderTenImage from '../../assets/images/slider_0009_tripadvisor-min.jpg'
import SliderElevenImage from '../../assets/images/slider_0010_tripadvisor-min.jpg'
import SliderTwelveImage from '../../assets/images/slider_0011_tripadvisor-min.jpg'
import SliderThirteenImage from '../../assets/images/slider_0012_tripadvisor-min.jpg'
import SliderFourteenImage from '../../assets/images/slider_0013_tripadvisor-min.jpg'
import SliderFifteenImage from '../../assets/images/slider_0014_tripadvisor-min.jpg'
import SliderSixteenImage from '../../assets/images/slider_0015_tripadvisor-min.jpg'
import SliderSeventeenImage from '../../assets/images/slider_0016_tripadvisor-min.jpg'
import SliderEighteenImage from '../../assets/images/slider_0017_tripadvisor-min.jpg'
import SliderNineteenImage from '../../assets/images/slider_0018_tripadvisor-min.jpg'



import "./GallerySection.css"

const GallerySection = () => {

    //create an array of slider images
    const sliderImages = [ 
        SliderOneImage, SliderTwoImage, SliderThreeImage, SliderFourImage, SliderFiveImage, SliderSixImage, SliderSevenImage, 
    SliderEightImage, SliderNineImage, SliderElevenImage, SliderTwelveImage, SliderThirteenImage, SliderFourteenImage, 
    SliderFifteenImage, SliderSixteenImage, SliderSeventeenImage, SliderEighteenImage, SliderNineteenImage 
    ];


    const sliderImageComponents = sliderImages.map((sliderImage, index) => {

        return (
            <li className="el-item uk-width-5-6 uk-width-1-3@s uk-width-1-4@m" key={index}>
                <img src={sliderImage} alt="Images From Customers" width="400" height="auto" className='gallery-image'/>
            </li>
        )
    });


  return (
    <>
        <div className='uk-section-default uk-section uk-section-large' uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay:100; offset-top: 100; repeat: true;">

        <div className="tm-grid-expand uk-child-width-1-1 uk-grid-margin uk-grid uk-grid-stack" uk-grid="">
            <div className="uk-width-1-1 uk-first-column">
    
            <div className='trip-heading-display uk-text-center trip-ultra uk-margin-large-bottom' uk-scrollspy-class="uk-animation-slide-bottom-medium"> 
            We posted pics <span className='camera-up'> <CameraComponent/>  </span><br/>along the way. 
            </div>

                            <div className="uk-margin-small uk-text-center uk-slider uk-slider-container gallery" tabIndex="-1" uk-slider="autoplay: true; center: true">

                                <div className="uk-position-relative">
                                    
                                    <ul className="uk-slider-items uk-grid uk-grid-small" style={{transform: "translate3d(-125.875px, 0px, 0px)"}}>
                                        {sliderImageComponents}                                     
                                    </ul>

                                </div>

                            </div>

                            <div className='trip-heading-display uk-text-center trip-ultra uk-margin-large-top' uk-scrollspy-class="uk-animation-slide-top-medium"> 
                                <span className='trip-ultra'> 18MM </span> &nbsp;times, to be exact.
                            </div>
                                                                                   
        </div>
</div>


            
        </div>
    </>
  )
}

export default GallerySection